<ng-template [ngIf]="survey">
  <div class="holder {{ survey.lpKey }}">
    <div class="inner-holder">
      <div class="logo-holder">
        <img [src]="logoSrc" [alt]="survey.lpKey" />
      </div>

      <div class="lp-top-left">
        <img src="/assets/lp/{{ survey.lpKey }}/top-left-thanks.png" />
      </div>
      <div class="lp-top-right">
        <img src="/assets/lp/{{ survey.lpKey }}/top-right-thanks.png" />
      </div>

      <div class="text-holder" *ngIf="survey.lpKey === 'peynirci'">
        <b
          >Bu kampanya şu an için sonlanmıştır. Sosyal medya hesabımızdan bu
          kampanyanın ve yeni kampanyaları takip edebilirsiniz</b
        >
      </div>
    </div>
  </div>
</ng-template>
